import { createClient } from "@supabase/supabase-js";

// ⚠️ DEMO — point this at your SEPARATE "Wilco Data Solutions" Supabase project,
// NOT the honey business project. Replace both values with the new project's
// URL and publishable/anon key (Project Settings → API).
export const SUPABASE_URL = "https://hmwnbwffzxjayzktcjne.supabase.co";
const SUPABASE_KEY = "sb_publishable_DiVoYz-MZj4FNGt7Pu6T3w_hiECyCxg";

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
